import type { TabTemplateDetailsEntity } from '../../tab-template-details/TabTemplateDetails.entity';
import type { TRenderScreen } from '../SettingsScreenRendererService';

import { TabTemplateDetails } from '../../tab-template-details/TabTemplateDetails';

export function renderTabTemplatesDetailsScreen(screen: TabTemplateDetailsEntity): TRenderScreen {
  return () => <TabTemplateDetails screen={screen} />;
}
